import React, { useState } from "react";
import { Typography, Button, Slide } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";

import VizSensor from "react-visibility-sensor";
import Overlay from "./Overlay";

const useStyle = makeStyles((theme) => ({
  container: {
    width: "400px",
    height: "450px",
    [theme.breakpoints.down("xs")]: {
      width: "100vw",
    },
    display: "flex",
    flexDirection: "column",
  },
  imgDiv: {
    width: "100%",
    height: "60%",
  },
  textDiv: {
    width: "100%",
    height: "40%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  btn: {
    marginTop: "10px",
  },
}));

const InfoCard = (props) => {
  const { direction, timer, data } = props;
  const theme = useTheme();
  const [modalOpen, setModelOpen] = useState(false);
  const [active, setActive] = useState(false);
  const classes = useStyle(theme);
  const handleOpen = () => {
    setModelOpen(true);
  };
  const handleClose = () => {
    setModelOpen(false);
  };
  return (
    <>
      <VizSensor
        partialVisibility
        onChange={(isVisible) => {
          setActive(isVisible);
        }}
      >
        <Slide direction={direction} in={active} timeout={timer}>
          <div className={classes.container}>
            <div className={classes.imgDiv}>{props.children}</div>
            <div className={classes.textDiv}>
              <Typography variant="h4" style={{ textAlign: "center" }}>
                {data.phraseOne}
              </Typography>
              {data.phraseTwo ? (
                <Typography variant="h4" style={{ textAlign: "center" }}>
                  {data.phraseTwo}
                </Typography>
              ) : null}

              <div>
                <Button
                  variant="outlined"
                  color="secondary"
                  className={classes.btn}
                  onClick={handleOpen}
                >
                  Learn more
                </Button>
              </div>
            </div>
            <Overlay
              text={data.summary}
              title={data.title}
              modalOpen={modalOpen}
              close={handleClose}
            />
          </div>
        </Slide>
      </VizSensor>
    </>
  );
};

export default InfoCard;
